import { useState, useEffect, useCallback } from 'react';
import salesforceRaiseMetricsService from 'services/salesforceRaiseMetricsService';

const useSalesforceRaiseMetrics = (entityId) => {
	const [metrics, setMetrics] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const fetchMetrics = useCallback(async (options = {}) => {
		if (!entityId) return;

		const { showLoading = true } = options;

		if (showLoading) {
			setLoading(true);
		}
		setError(null);

		try {
			const data = await salesforceRaiseMetricsService.getRaiseMetrics(entityId);
			setMetrics(data);
		} catch (err) {
			// authedApiFetch embeds the HTTP status in err.message; map the codes the
			// backend uses so the panel can show a meaningful message (mirrors useSalesforceTasks).
			if (err.message?.includes('404')) {
				setError('not_connected');
			} else if (err.message?.includes('403')) {
				setError('access_denied');
			} else {
				setError('unavailable');
			}
			setMetrics(null);
		} finally {
			if (showLoading) {
				setLoading(false);
			}
		}
	}, [entityId]);

	useEffect(() => {
		fetchMetrics();
	}, [fetchMetrics]);

	return { metrics, loading, error, refetch: fetchMetrics };
};

export default useSalesforceRaiseMetrics;
